module.exports = __webpack_public_path__ + "img/glamping.1b39bf12.jpg";